import styled from 'styled-components';

import { FONTS } from '~/src/common/theme';
import { COLORS } from '~/src/common/theme';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Gears = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 8px;
  border-radius: 4px;
  background: ${COLORS.GROUND_UNDERGROUND};
`;

export const GearTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`;

export const Gear = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
`;

export const StepContainer = styled.div`
  padding: 16px;
  border-radius: 4px;
  border: 1px solid ${COLORS.NEUTRAL_STROKE};

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const StepNumber = styled.p`
  margin: 0 0 8px;
  font-size: 28px;
  font-weight: 700;
  line-height: 32px;
  font-family: ${FONTS.ARTZ};
  color: ${COLORS.ACTION_DEFAULT};
`;

export const IngredientsList = styled.div`
  display: grid;
  gap: 24px;
  margin: 16px 0 0;
  padding: 24px 0 0;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid ${COLORS.NEUTRAL_STROKE};

  & > div {
    display: flex;
    overflow: hidden;
    align-items: center;
  }
`;
